/* MCE Grouped Finish Picker — staging build 2026-08-04
   Drives Canopy's own variant-picker radios, so price/availability/media/cart
   logic is untouched. Canopy replaces the picker DOM on every variant change,
   so enhancement re-applies via MutationObserver. */
(function () {
  'use strict';

  var TIER_LABELS = {
    unfinished_clear: { title: 'Unfinished & Clear', note: 'honest raw tin — finish it your way' },
    powder: { title: 'Powder-Coated', note: 'premium factory finish' },
    artistin: { title: 'ArtisTin™', note: 'digitally-printed artisan character' },
    other: { title: 'More Finishes', note: '' }
  };
  var TIER_ORDER = ['unfinished_clear', 'powder', 'artistin', 'other'];

  function getData(sectionEl) {
    var dataEl = sectionEl.querySelector('.mce-finish-data');
    if (!dataEl) return null;
    try {
      var d = JSON.parse(dataEl.textContent);
      return (d && d.colors && d.colors.length) ? d : null;
    } catch (e) { return null; }
  }

  function dispatchChange(input) {
    input.checked = true;
    input.dispatchEvent(new CustomEvent('change', { bubbles: true, cancelable: false, detail: { noFocus: true } }));
  }

  function suppressTileOptions(vp) {
    var sel = vp.querySelector('.option-selector[data-option="Tile Options"]');
    if (!sel) return;
    var regular = sel.querySelector('.js-option[value="Regular"]');
    if (regular && !regular.checked) dispatchChange(regular);
    sel.classList.add('mce-hidden');
  }

  /* Show the "Unfinished panels require a protective finish" note only when
     the Unfinished color is selected (John, 8/4). Targeted by text match so
     no template surgery is needed; if the copy is ever rewritten past
     recognition, the note simply reverts to always-visible. */
  function toggleUnfinishedNote(sectionEl, colorSel) {
    var note = null;
    sectionEl.querySelectorAll('.product-info__block.rte').forEach(function (b) {
      if (b.textContent.indexOf('Unfinished panels require') !== -1) note = b;
    });
    if (!note) return;
    var checked = colorSel.querySelector('.js-option:checked');
    note.classList.toggle('mce-hidden', !(checked && checked.value === 'Unfinished'));
  }

  function buildTiers(vp, colorSel, data) {
    var byName = {};
    data.colors.forEach(function (c) { byName[c.name] = c; });

    var radios = Array.prototype.slice.call(colorSel.querySelectorAll('.js-option'));
    if (!radios.length) return;

    // Group this product's actual option values by tier
    var groups = {};
    radios.forEach(function (radio) {
      var meta = byName[radio.value];
      var tier = meta ? meta.tier : 'other';
      (groups[tier] = groups[tier] || []).push({ radio: radio, meta: meta });
    });

    var wrap = document.createElement('div');
    wrap.className = 'mce-tiers';

    var selName = document.createElement('div');
    selName.className = 'mce-selected-name';
    wrap.appendChild(selName);

    function refreshSelected() {
      var checked = colorSel.querySelector('.js-option:checked');
      selName.innerHTML = 'Color: <b></b>';
      selName.querySelector('b').textContent = checked ? checked.value : '—';
      wrap.querySelectorAll('.mce-swatch').forEach(function (btn) {
        btn.classList.toggle('is-selected', !!checked && btn.dataset.mceValue === checked.value);
      });
      toggleUnfinishedNote(vp.closest('.shopify-section'), colorSel);
    }

    TIER_ORDER.forEach(function (tier) {
      var items = groups[tier];
      if (!items || !items.length) return;
      items.sort(function (a, b) {
        var ao = a.meta ? a.meta.order : 999; var bo = b.meta ? b.meta.order : 999;
        return ao - bo;
      });

      var tierEl = document.createElement('div');
      tierEl.className = 'mce-tier';
      var head = document.createElement('div');
      head.className = 'mce-tier__head';
      var label = TIER_LABELS[tier] || TIER_LABELS.other;
      head.innerHTML = '<span></span><span class="mce-tier__note"></span>';
      head.children[0].textContent = label.title;
      head.children[1].textContent = label.note;
      tierEl.appendChild(head);

      var grid = document.createElement('div');
      grid.className = 'mce-swatches';
      items.forEach(function (item) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mce-swatch';
        btn.dataset.mceValue = item.radio.value;
        btn.title = item.radio.value;
        btn.setAttribute('aria-label', 'Color: ' + item.radio.value);
        if (item.meta && item.meta.image) {
          btn.classList.add('mce-swatch--img');
          btn.style.backgroundImage = 'url(' + item.meta.image + ')';
        } else {
          btn.style.background = (item.meta && item.meta.hex) ? item.meta.hex : '#d8d8d8';
        }
        if (item.radio.classList.contains('is-unavailable')) btn.classList.add('is-unavailable');
        btn.addEventListener('click', function () {
          var live = colorSel.querySelector('.js-option[value="' + CSS.escape(item.radio.value) + '"]');
          if (live && !live.checked) dispatchChange(live);
          refreshSelected();
        });
        grid.appendChild(btn);
      });
      tierEl.appendChild(grid);
      wrap.appendChild(tierEl);
    });

    // Hide the flat strip + its legend, insert grouped UI
    var strip = colorSel.querySelector('.option-selector__btns');
    if (strip) strip.classList.add('mce-hidden');
    var legend = colorSel.querySelector('legend');
    if (legend) legend.classList.add('mce-hidden');
    colorSel.appendChild(wrap);
    refreshSelected();

    // Keep selection state in sync if a change originates elsewhere
    vp.addEventListener('change', function () { setTimeout(refreshSelected, 0); });
  }

  /* Append "$X.XX / sq ft" under the displayed price (24"×24" tile = 4 sq ft).
     The price block is variant-dynamic content — Canopy replaces it on every
     variant change, so this re-applies via scan() and on:variant:change. */
  function updateSqftPrice(sectionEl) {
    var priceEl = sectionEl.querySelector('.product-info__price');
    if (!priceEl) return;
    var m = priceEl.textContent.match(/\$\s?([\d,]+(?:\.\d{1,2})?)/);
    if (!m) return;
    var perSqft = parseFloat(m[1].replace(/,/g, '')) / 4;
    if (!(perSqft > 0)) return;
    var tag = priceEl.querySelector('.mce-price-sqft');
    if (!tag) {
      tag = document.createElement('span');
      tag.className = 'mce-price-sqft';
      priceEl.appendChild(tag);
    }
    tag.textContent = '$' + perSqft.toFixed(2) + ' / sq ft · 24" × 24" tile covers 4 sq ft';
  }

  function enhance(vp) {
    if (vp.dataset.mceEnhanced) return;
    var sectionEl = vp.closest('.shopify-section');
    if (!sectionEl) return;
    var data = getData(sectionEl);
    if (!data) return; // template without our data island — leave native picker alone
    var colorSel = vp.querySelector('.option-selector[data-option="Color"]');
    if (!colorSel) return;
    vp.dataset.mceEnhanced = '1';
    suppressTileOptions(vp);
    buildTiers(vp, colorSel, data);
  }

  function refreshSqftAll() {
    document.querySelectorAll('.mce-finish-data').forEach(function (dataEl) {
      var sectionEl = dataEl.closest('.shopify-section');
      if (sectionEl) updateSqftPrice(sectionEl);
    });
  }

  function scan() {
    document.querySelectorAll('variant-picker:not([data-mce-enhanced])').forEach(function (vp) {
      // try/catch per picker so one failure can't kill the loop
      try { enhance(vp); } catch (e) { /* leave native picker in place */ }
    });
    try { refreshSqftAll(); } catch (e) { /* non-critical */ }
  }

  function init() {
    scan();
    document.addEventListener('on:variant:change', function () { setTimeout(refreshSqftAll, 30); });
    // NOTE: setTimeout, NOT requestAnimationFrame — rAF is suspended in
    // background tabs, which permanently wedged the debounce flag (8/4 bug).
    var timer = null;
    var observer = new MutationObserver(function () {
      if (timer) return;
      timer = setTimeout(function () { timer = null; scan(); }, 40);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
